document.addEventListener("DOMContentLoaded", function () {
  function setSingaporeDefault() {
    const select = document.querySelector("#wRegisterForm-select-2");
    if (select) {
      select.value = "+65"; // set Singapore as default
      // in case the app triggers change events
      select.dispatchEvent(new Event("change", { bubbles: true }));
      return true;
    }
    return false;
  }

  // Try immediately
  if (!setSingaporeDefault()) {
    // If not available yet, observe until it's added
    const observer = new MutationObserver(() => {
      if (setSingaporeDefault()) {
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
});
document.addEventListener('DOMContentLoaded', function () {
  const links = document.querySelectorAll('a[href]');

  links.forEach(link => {
    const href = link.getAttribute('href');

    // Skip anchors and JS links
    if (
      !href ||
      href.startsWith('#') ||
      href.startsWith('javascript:')
    ) {
      return;
    }

    try {
      const url = new URL(href, window.location.href);

      if (url.hostname !== window.location.hostname) {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      }
    } catch (e) {
      // Invalid URL - skip
      return;
    }
  });
});
document.querySelectorAll('.show_password').forEach(function(toggleBtn) {
  toggleBtn.addEventListener('click', function() {
    const passwordField = this.parentElement.querySelector('#CustomerPassword, #RegisterForm-password');
    if (passwordField) {
      const fieldType = passwordField.getAttribute('type');
      passwordField.setAttribute('type', fieldType === 'password' ? 'text' : 'password');
    }
  });
});
$(document).ready(function() {

  if(window.location.hash == '#recover'){
    $("html, body").animate({ scrollTop: 80 }, "slow");
  }
  $('.cst-forget-password,.cst-cancel').click(function(){
    $("html, body").animate({ scrollTop: 80 }, "slow");
  });

});  


(function() {
  const customClass = "equal-p-height-section"; // Add this class to the section wrapper

  function setEqualPHeights(section = document) {
    // Only target sections with the custom class
    const cards = section.querySelectorAll(`.${customClass} .multicolumn-card__info .rte.typeset`);
    if (!cards.length) return;
    // Reset all heights first
    cards.forEach(card => {
      card.querySelectorAll("p").forEach(p => p.style.height = "auto");
    });
    // Only apply on desktop/tablet >= 768px
    if (window.innerWidth < 768) return;
    const maxHeights = [];
    // Find max height for each <p> index
    cards.forEach(card => {
      const ps = card.querySelectorAll("p");
      ps.forEach((p, i) => {
        const h = p.offsetHeight;
        maxHeights[i] = Math.max(maxHeights[i] || 0, h);
      });
    });
    // Apply max height to all corresponding <p>
    cards.forEach(card => {
      const ps = card.querySelectorAll("p");
      ps.forEach((p, i) => {
        p.style.height = maxHeights[i] + "px";
      });
    });
  }
  // Initial run on page load
  window.addEventListener("DOMContentLoaded", () => setEqualPHeights());
  // Re-run on window resize
  window.addEventListener("resize", () => setEqualPHeights());
  // Shopify section events (editor/live)
  document.addEventListener("shopify:section:load", e => setEqualPHeights(e.target));

})();
